import { useEffect, useState } from "react";
import { Header } from "./inscription";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { RoundGreyPlain } from "components/ui/Buttons/generic/GenericButton";
import { create } from "services/parcours/create-entreprise.service";
import { requestInfos } from "store";
import { useRecoilState } from "recoil";

const setDescription = (desc: any) => {
    const el = document.querySelector("meta[name='description']");
    if(el!== null){
        el.setAttribute('content',desc);
    }
}
let errors:any={password:{status: true, message: "Mot de passe requis."},confirm_password:{status: true, message: "Confirmation de mot de passe requis."}};
export default function ResetPassword(){
    const [connecting, setConnecting]= useState(false);
    

    let [searchParams, _] = useSearchParams()

    const [hasErrors, setHasErrors] = useState({password:{status: false, message: ""},confirm_password:{status: false, message: ""}})
    
    const params:any ={
        name: searchParams.get('name') ?? '',
        token: searchParams.get('token') ?? '',
        email: searchParams.get('email') ?? ''
    }



    const [credentials, setCredentials]= useState<{password: string, confirm_password: string}>({password: "", confirm_password: ""});
    const handleInputs= (event: any) => {
        event.preventDefault();
        if(!event.currentTarget.value){
            errors = {...errors, [event.currentTarget.name]: {status: true, message: "Veuillez remplir ce champ"} };
        }else{
            if(event.currentTarget.name === 'confirm_password'){
                console.log(event.currentTarget?.value !== credentials.password)
                if(event.currentTarget?.value !== credentials.password){
                    errors = {...errors, [event.currentTarget.name]: {status: true, message: "Mot de passe ne correspondent pas"} };
                }else{
                    errors[event.currentTarget.name] = {status: false,message: ''}
                }
            }else{
                errors[event.currentTarget.name] = {status: false,message: ''}
            }
        }
        setCredentials({...credentials, [event.currentTarget.name]: event.currentTarget.value});
    };
    const history= useNavigate();

    const validate=(str: string)=>{
        return str.toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    };

    const navigate = useNavigate()
    const [requestInfosAtom, setRequestInfosAtom] = useRecoilState(requestInfos)

    // console.log(JSON.stringify(errors))

    const handleReset= async (event: any) => {
        try {
            if(Object.values(errors).some((el:any)=>el.status === true)){
                setHasErrors(errors)
            }else{
                setHasErrors({password:{status: false, message: ""},confirm_password:{status: false, message: ""}})
                let formData = new FormData()
    
                formData.append('token', params.token)
                formData.append('password', credentials.password)
                formData.append('confirmPassword', credentials.confirm_password)

                setConnecting(true)

                const url:string = `https://portal.wall-of-share${window.location.hostname.includes('.com')?'.com':'.fr'}/web/reset_password?db=wos_db`
    
                const res = await create(formData, url)


                setRequestInfosAtom({
                    ...requestInfosAtom,
                    success:{
                        message: requestInfosAtom.success.message,
                        description: res.message,
                        backToLogin:true
                    }
                })

                setTimeout(()=>{
                    setConnecting(false);
                    history(`/merci`)
                },1000)
                
    
                console.log({res})
            }

        } catch (error:any) {
            console.log({error:error?.message})
            setRequestInfosAtom({
                ...requestInfosAtom,
                error:{
                    message: requestInfosAtom.error.message,
                    description: error?.message
                }
            })

            setTimeout(()=>{
                setConnecting(false);
                history(`/erreur`)
            },2000)
            // navigate('/erreur')
        }finally{
            setConnecting(false)
        }
    };

    return<>
        <div className="w-full min-h-[100vh] bg-[#f4f4f5]">
            <Header backTo={"/connexion"}/>
            <div className="flex flex-col gap-[69px] items-center py-[110px] w-[80vw] max-w-[766px] mx-auto">
                <div className="flex flex-col gap-[10px] lg:max-w-[535px] max-w-[80vw] lg:mx-0 mx-auto self-start">
                    <h1 className="lg:text-[60px] lg:leading-[72px] text-[40px] leading-[48px] text-primary-blue font-semibold">Veuillez définir votre mot de passe</h1>
                    {/* <p className="lg:text-[25px] lg:leading-[32.55px] text-[20px] leading-[26.04px] text-[#6f6f6f] font-normal font-dm-sans">Entrez votre adresse e-mail ci-dessous et nous vous enverrons un lien pour réinitialiser votre mot de passe.</p> */}
                </div>
                <form onSubmit={handleReset} className="w-full flex flex-col lg:max-w-[766px] max-w-[80vw] gap-x-[69px] gap-y-[2rem]">
                    {/* <div className="flex flex-col gap-[10px] w-full">
                        <input type="email" readOnly disabled className="w-full rounded-[100px] bg-white px-[30px] py-[20px] font-normal font-dm-sans md:text-[25px] md:leading-[32.55px] text-[20px] leading-[26.04px] text-[#6f6f6f]" name="login" placeholder="Nom d'utilisateur" value={params?.email} onChange={handleInputs} />
                    </div>
                    <div className="flex flex-col gap-[10px] w-full">
                        <input type="text" className="w-full rounded-[100px] bg-white px-[30px] py-[20px] font-normal font-dm-sans md:text-[25px] md:leading-[32.55px] text-[20px] leading-[26.04px] text-[#6f6f6f]" name="name" placeholder="Nom" readOnly disabled value={params.name} onChange={handleInputs} />
                    </div> */}
                    <div className="flex flex-col gap-[20px] w-full">
                        <input type="password" className="w-full rounded-[100px] bg-white px-[30px] py-[20px] font-normal font-dm-sans md:text-[25px] md:leading-[32.55px] text-[20px] leading-[26.04px] text-[#6f6f6f]" name="password" placeholder="Mot de passe" value={credentials.password} onChange={handleInputs} style={hasErrors['password'].status? {border: "1px solid red"}: {}} />
                        {hasErrors['password']?.status && <div className="text-[#f55] lg:text-[25px] lg:leading-[32.55px] text-[20px] leading-[26.04px] font-normal font-dm-sans">{hasErrors['password'].message}</div>}
                    </div>
                    <div className="flex flex-col gap-[20px] w-full">
                        <input type="password" className="w-full rounded-[100px] bg-white px-[30px] py-[20px] font-normal font-dm-sans md:text-[25px] md:leading-[32.55px] text-[20px] leading-[26.04px] text-[#6f6f6f]" name="confirm_password" placeholder="Confirmer Mot de passe" value={credentials.confirm_password} onChange={handleInputs} style={hasErrors['confirm_password'].status? {border: "1px solid red"}: {}} />
                        {hasErrors['confirm_password']?.status && <div className="text-[#f55] lg:text-[25px] lg:leading-[32.55px] text-[20px] leading-[26.04px] font-normal font-dm-sans">{hasErrors['confirm_password'].message}</div>}
                    </div>
                    <div className="flex flex-col gap-[28px] w-full">
                        <RoundGreyPlain isButton={true} className="w-full flex items-center justify-center py-[20px] md:text-[25px] md:leading-[30px] text-[20px] leading-[24px] font-semibold" isLoading={connecting} text={connecting ? "Envoi..." : "Soumettre votre mot de passe"} onClick={handleReset}/>
                        <p className="font-normal text-[20px] leading-[24px] text-primary-blue lg:text-left text-center max-w-[80vw] mx-auto md:mt-0 mt-[23.5px]">Vous n'avez pas encore de compte ? <Link className="font-semibold underline decoration-solid" to="/inscription">Inscrivez-vous</Link></p>
                    </div>
                </form>
            </div>
        </div>
    </>
};
